module.exports = __webpack_public_path__ + "static/media/HO12.715f20a1.png";